import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Sparkles } from 'lucide-react';
export function TransformationSection() {
  const benefits = ["Te arreglas más rápido sin sentirte 'a medias'", 'Dejas de gastar por ansiedad', 'Sabes qué hacer cuando hay humedad, lluvia o calor', 'Tienes un plan para días malos (no pánico)', 'Y empiezas a sentir algo que muchas mujeres no han sentido en años: CONTROL'];
  return <section className="py-20 md:py-32 bg-cream-50" data-id="element-326">
      <div className="max-w-4xl mx-auto px-6" data-id="element-327">
        <FadeIn className="text-center mb-16" data-id="element-328">
          <h2 className="text-3xl md:text-5xl font-serif text-brown-900" data-id="element-329">
            Lo que cambia en tu vida <br data-id="element-330" />
            <span className="italic text-terracotta text-2xl md:text-4xl" data-id="element-331">
              (sin promesas raras)
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-332">
          {benefits.map((benefit, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-333">
              <div className="flex items-center gap-4 bg-white p-6 rounded-xl shadow-sm border border-brown-900/5 hover:border-terracotta/30 transition-colors" data-id="element-334">
                <Sparkles className="w-6 h-6 text-terracotta shrink-0" data-id="element-335" />
                <p className="text-lg md:text-xl text-brown-800" data-id="element-336">
                  {benefit.includes('CONTROL') ? <>
                      {benefit.replace('CONTROL', '')}
                      <strong className="text-terracotta font-serif text-2xl tracking-wide" data-id="element-337">
                        CONTROL
                      </strong>
                    </> : benefit}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}